import {currentUserModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;

export const canSeeStudyPatientAuditTrail = function() {
    return currentUserModule.hasRight(Rights.AuditTrailGetStudyPatientCmd);
}

export const canSeeVisitAuditTrail = function() {
    return currentUserModule.hasRight(Rights.AuditTrailGetVisitCmd);
}

export const canSeeInstrumentAuditTrail = function() {
    return currentUserModule.hasRight(Rights.AuditTrailGetInstrumentCmd);
}

export const canSeeQueryAuditTrail = function() {
    return currentUserModule.hasRight(Rights.AuditTrailGetQueryCmd);
}

export const canSeeStudyInstituteTrail = function() {
    return currentUserModule.hasRight(Rights.AuditTrailGetStudyInstituteCmd);
}

export const canSeeUserAuditTrail = function() {
    return currentUserModule.hasRight(Rights.AuditTrailGetUserCmd);
}

